<div class="modal-header">
    <div class="row col-12">
        <div class="modal-title col-10">
            <h4>Egenskaber for: {{ DbTemplateInfo.dbTemplate.name }}</h4> <span class="fw-bold">Id: [{{ DbTemplateInfo.dbTemplate.id }}]</span>
        </div>
        <div class="col-2 align-self-center">
            <div class="text-end">
                <button type="button" class="btn" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
                    <span aria-hidden="true"><i class="fa-solid fa-x"></i></span>
                </button>
            </div>
        </div>
    </div>
</div>

<div class="modal-body col-12">
    <div class="row ms-2">
        <div class="col-sm-12">
            <div class="form-check form-switch">
                <label class="form-check-label" for="read">Læse</label>
                <input class="form-check-input" type="checkbox" id="read"
                        [(ngModel)]="DbTemplateInfo.dbTemplate.allowRead">
            </div>
        </div>
    </div>

    <hr class="mt-2">
    <div class="row mt-2 ms-2">
        <div class="col-sm-12">
            <div class="form-check form-switch">
                <label class="form-check-label" for="read-direct">Tillad direkte læsning</label>
                <input class="form-check-input" type="checkbox"
                    id="read-direct" [(ngModel)]="DbTemplateInfo.dbTemplate.allowSynchronousCall" >
            </div>
        </div>
    </div>

    <div class="row mt-2 ms-2">
        <div class="col-sm-12">
            <div class="form-check form-switch">
                <label class="form-check-label" for="read-all">Tillad læsning uden filter</label>
                <input [disabled]="!DbTemplateInfo.dbTemplate.allowRead" class="form-check-input" type="checkbox"
                    id="read-all" [(ngModel)]="DbTemplateInfo.dbTemplate.allowReadAll" >
            </div>
        </div>
    </div>

    <div class="row mt-2 ms-2">
        <div class="col-sm-3">
            <div class="form-check form-switch mt-2">
                <label class="form-check-label" for="read-limit">Læsegrænse</label>
                <input [disabled]="!DbTemplateInfo.dbTemplate.allowRead" class="form-check-input" type="checkbox"
                    id="read-limit" [(ngModel)]="DbTemplateInfo.dbTemplate.enableRecordReadLimit">
            </div>
        </div>
        <div class="col-sm-4">
            <div class="input-group">
                <span class="input-group-text">Max. antal poster</span>
                <input [disabled]="!DbTemplateInfo.dbTemplate.enableRecordReadLimit || !DbTemplateInfo.dbTemplate.allowRead" type="number" class="form-control text-end"
                [(ngModel)]="DbTemplateInfo.dbTemplate.recordReadLimit">
            </div>
        </div>
    </div>

    <div class= "row mt-2 ms-2">
        <div class="col-sm-3">
            <div class="form-check form-switch mt-2">
                <label class="form-check-label" for="read-pre">Førbehandling: </label>
                <input [disabled]="!DbTemplateInfo.dbTemplate.allowRead" class="form-check-input" type="checkbox" id="read-pre" [(ngModel)]="DbTemplateInfo.dbTemplate.preProcessingOnRead">
            </div>
        </div>
        <div class="col-sm-3">
            <div class="form-check form-switch mt-2">
                <label class="form-check-label" for="read-post">Efterbehandling: </label>
                <input [disabled]="!DbTemplateInfo.dbTemplate.allowRead" class="form-check-input" type="checkbox" id="read-post" [(ngModel)]="DbTemplateInfo.dbTemplate.postProcessingOnRead">
            </div>
        </div>
    </div>
    <hr class="mt-4">

    @if (DbTemplateInfo.dbTemplate.dbObjectType == dbObjectTypeEnum.Table) 
    {
        <div class="row ms-2 mt-4">
            <div class="col-sm-12">
                <div class="form-check form-switch">
                    <label class="form-check-label" for="write">Skrive </label>
                    <input class="form-check-input" type="checkbox" id="write"
                        [(ngModel)]="DbTemplateInfo.dbTemplate.allowWrite">
                </div>
            </div>
        </div>

        <hr class="mt-2">
        
        <div class= "row mt-2 ms-2">
            <div class="col-sm-3">
                <div class="form-check form-switch mt-2">
                        <label class="form-check-label" for="write-pre">Førbehandling: </label>
                        <input [disabled]="!DbTemplateInfo.dbTemplate.allowWrite" class="form-check-input" type="checkbox" id="write-pre" [(ngModel)]="DbTemplateInfo.dbTemplate.preProcessingOnWrite">
                    </div>
                </div>
                <div class="col-sm-3">
                    <div class="form-check form-switch mt-2">
                        <label class="form-check-label" for="write-post">Efterbehandling: </label>
                        <input [disabled]="!DbTemplateInfo.dbTemplate.allowWrite" class="form-check-input" type="checkbox" id="write-post" [(ngModel)]="DbTemplateInfo.dbTemplate.postProcessingOnWrite">
                    </div>
                </div>
            </div>

        <div class="row mt-2 ms-2">
            <div class="col-sm-12">
                <div class="form-check form-switch">
                    <label class="form-check-label" for="write-eos">EOS (NAV) – førbehandlingen udfylder koder, numre og beskrivelser ud fra Guids</label>
                    <input [disabled]="!DbTemplateInfo.dbTemplate.allowWrite" class="form-check-input" type="checkbox" id="write-eos" [(ngModel)]="DbTemplateInfo.dbTemplate.isEos">
                </div>
            </div>
        </div>

        <hr class="mt-4">

        <div class="row ms-2 mt-4">
            <div class="col-sm-12">
                <div class="form-check form-switch">
                    <label class="form-check-label" for="delete">Slette</label>
                    <input class="form-check-input" type="checkbox" id="delete"
                        [(ngModel)]="DbTemplateInfo.dbTemplate.allowDelete">
                </div>
            </div>
        </div>

        <hr class="mt-2">
        
        <div class= "row mt-2 ms-2">
            <div class="col-sm-3">
                <div class="form-check form-switch mt-2">
                    <label class="form-check-label" for="delete-pre">Førbehandling: </label>
                    <input [disabled]="!DbTemplateInfo.dbTemplate.allowDelete" class="form-check-input" type="checkbox" id="delete-pre" [(ngModel)]="DbTemplateInfo.dbTemplate.preProcessingOnDelete">
                </div>
            </div>
            <div class="col-sm-3">
                <div class="form-check form-switch mt-2">
                    <label class="form-check-label" for="delete-post">Efterbehandling: </label>
                    <input [disabled]="!DbTemplateInfo.dbTemplate.allowDelete" class="form-check-input" type="checkbox" id="delete-post" [(ngModel)]="DbTemplateInfo.dbTemplate.postProcessingOnDelete">
                </div>
            </div>
        </div>
    }

    <hr class="mt-4">

    <div class="row ms-2 mt-4">
        <div class="col-sm-12 fw-bold">Afdelingsrettigheder</div>
        <div class="col-sm-12 text-muted small">Hvad afdelingerne må med skabeloner baseret på denne databaseskabelon.</div>
    </div>

    <div class="row mt-2 ms-2">
        <div class="col-sm-12">
            <div class="form-check form-switch">
                <label class="form-check-label" for="department-create">Opret – afdelingen må oprette skabeloner ud fra databaseskabelonen</label>
                <input class="form-check-input" type="checkbox" id="department-create"
                    [(ngModel)]="DbTemplateInfo.dbTemplate.departmentAllowCreate">
            </div>
        </div>
    </div>

    <div class="row mt-2 ms-2">
        <div class="col-sm-12">
            <div class="form-check form-switch">
                <label class="form-check-label" for="department-edit">Rediger – afdelingen må rette felterne (ellers kun aktiv, navn og beskrivelse)</label>
                <input class="form-check-input" type="checkbox" id="department-edit"
                    [(ngModel)]="DbTemplateInfo.dbTemplate.departmentAllowEdit">
            </div>
        </div>
    </div>

    <div class="row mt-2 ms-2">
        <div class="col-sm-12">
            <div class="form-check form-switch">
                <label class="form-check-label" for="department-delete">Slet – afdelingen må slette skabelonen</label>
                <input class="form-check-input" type="checkbox" id="department-delete"
                    [(ngModel)]="DbTemplateInfo.dbTemplate.departmentAllowDelete">
            </div>
        </div>
    </div>
</div>

<div class="modal-footer bg-transparent">
    <button class="btn btn-danger float-end" (click)="activeModal.dismiss('luk')">Luk</button>
</div>